const Columns = [
    {
        Header: "#",
        accessor: "id",
    },
    {
        Header: "Code",
        accessor: "shortCode",
    },
    {
        Header: "Type",
        accessor: "type",
    },
    {
        Header: "isPublic",
        accessor: "isPublic",
    },
    {
        Header: "Created At",
        accessor: "createdAt",
    },
    {
        Header: "Source",
        accessor: "data.source",
    },
    {
        Header: "Medium",
        accessor: "data.medium",
    },
    {
        Header: "Campaign",
        accessor: "data.campaign",
    },
];
export { Columns };